import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export const CookieConsent = () => {
  const { t } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("sf_cookie")) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const decide = (choice) => {
    localStorage.setItem("sf_cookie", choice);
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 60 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:end-6 sm:max-w-md z-50 glass-dark rounded-2xl border border-white/10 p-5 shadow-2xl"
          data-testid="cookie-consent"
        >
          <div className="flex items-start gap-3">
            <Cookie className="w-5 h-5 text-gold shrink-0 mt-0.5" />
            <div>
              <p className="text-white/80 text-sm leading-relaxed mb-4">{t.cookie.text}</p>
              <div className="flex gap-3">
                <button onClick={() => decide("accepted")} data-testid="cookie-accept" className="rounded-full bg-gold text-charcoal text-sm font-semibold px-5 py-2 hover:bg-gold-soft transition-colors">
                  {t.cookie.accept}
                </button>
                <button onClick={() => decide("declined")} data-testid="cookie-decline" className="rounded-full border border-white/20 text-white/80 text-sm px-5 py-2 hover:bg-white/5 transition-colors">
                  {t.cookie.decline}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
